module.exports = __webpack_public_path__ + "assets/img/loophole.87142a39.svg";